import React, { useEffect, useState } from "react";
import Chart from "react-apexcharts";
import { Card, Row, Col, Form, ProgressBar, Table } from "react-bootstrap";
import { BsClockHistory } from "react-icons/bs";
import { PiUsers } from "react-icons/pi";
import { studyMedicalReviewServices } from "../../../../APIServices/studyMedicalReviewServices";
import { useParams } from "react-router";
import { PageLoader } from "../../../../Components/NoDataFoundTable/NoDataFoundTable";

const ReviewerPerformance = ({ onMouseDown, tableRef, dataType }) => {
  const [reviewerLoading, setReviewerLoading] = useState(false);
  const [reviewerStats, setReviewerStats] = useState([]);
  let { studyId } = useParams();
  const StudyMode = JSON.parse(localStorage.getItem("StudyMode"));

  const getMedicalTaskReviewerPerformance = async () => {
    setReviewerLoading(true)
    let data = await studyMedicalReviewServices.getMedicalTaskReviewerPerformance(studyId, "ALL", dataType, StudyMode)
    setReviewerStats(data?.data || [])
    setReviewerLoading(false)
  }

  useEffect(() => {
    getMedicalTaskReviewerPerformance();
  }, [studyId, dataType]);
  return (
    <>
      {reviewerLoading ?
        <PageLoader />
        :
        <div className="shadow-md border br3 bg-light h-100">
          <div className="d-flex justify-content-between align-items-center p-2 border-bottom">
            <Form.Label className="m-0 text-nowrap bold">
              <PiUsers className="me-2 text-info" /> Reviewer Performance
            </Form.Label>
          </div>
          <div className="p-2">
            <Table ref={tableRef} className="m-0 custom-table" hover striped>
              <thead className="position-sticky top-0 z-1">
                <tr>
                  <th onMouseDown={(e) => onMouseDown(e, 0)}>Reviewer</th>
                  <th onMouseDown={(e) => onMouseDown(e, 1)}>Completion</th>
                  <th onMouseDown={(e) => onMouseDown(e, 2)}>Reviewed</th>
                  <th onMouseDown={(e) => onMouseDown(e, 3)}>Queries</th>
                  <th onMouseDown={(e) => onMouseDown(e, 4)}>Avg. TAT</th>
                </tr>
              </thead>
              <tbody>
                {reviewerStats?.map((item, index) => (
                  <tr key={index}>
                    <td>
                      <div>{item?.userName}</div>
                      <small>Medical Reviewer</small>
                    </td>
                    <td>
                      <ProgressBar style={{ height: 4 }} className="border" variant="warning" now={item?.completion} />
                      <div className="text-end">{`${item?.completion}%`}</div>
                    </td>
                    <td>{item?.totalReview}</td>
                    <td>{item?.totalComment}</td>
                    <td>{item?.avgTurnaround}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        </div>
      }
    </>
  );
};


export default ReviewerPerformance;
